import {ROUTE} from '@/constants/main/route';
import {getRelativeRoute} from '@/utils/route';
import globalDomains, {globalAPPScheme} from '@/utils/global-domains';
import {isWebview} from '@/utils/helper';

export const getRelativeHelpRoute = (fullPath: string) => {
  return getRelativeRoute(fullPath, ROUTE.HELP.INDEX);
};

export const getNextPageNo = (currentPage?: number, count?: number) => {
  if (currentPage === undefined || count === undefined) {
    return undefined;
  }
  const totalPages = Math.ceil(count / 10);
  return currentPage < totalPages ? currentPage + 1 : undefined;
};

export const highlightKeyword = (text: string, keyword: string) => {
  if (!keyword) {
    return text;
  }

  // HTML 이스케이프 함수
  const escapeHtml = (str: string) => {
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  };

  // 텍스트와 키워드를 이스케이프
  let safeText = escapeHtml(text);
  let safeKeyword = escapeHtml(keyword);

  // 정규식 이스케이프
  let escapeRegExp = safeKeyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  let pattern = new RegExp(`${escapeRegExp.trim()}`, 'gi');
  const highlightText = safeText.replace(pattern, '<strong>$&</strong>');

  return highlightText;
};

export const goMobileMain = (): void => {
  try {
    if (isWebview) {
      // 모바일앱
      window.location.href = `${globalAPPScheme}go/home`;
    } else {
      // 모바일웹
      window.location.href = globalDomains.M_AFREECATV + '/#/home';
    }
  } catch (error) {
    console.warn('Failed to go mobile main:', error);
    window.location.href = globalDomains.WWW_AFREECATV;
  }
};

export const isHelpPath = (path: string) => {
  return path.startsWith('/help');
};
